export default __webpack_public_path__ + "e9a9dafedb97b651252b939e8fc2b5fe.svg";